import React from 'react';
import InitChatSvg from '../svg/InitChatSvg'

const ChatLanding = () => (
    <div className='flex flex-col justify-center items-center sm:rounded-lg sm:shadow-lg sm:bg-white h-full w-full'>
        <div className='h-auto w-3/5'>
            <div className='flex justify-center animate-pulse w-full'>
                <InitChatSvg />
            </div>
            <div className='text-center text-gray-200 font-bold text-2xl leading-6 w-full mt-4'>
                Stay Updated!
            </div>
            <div className='mt-4 text-gray-400 text-center leading-5 text-sm'>
                Connect with your fellow students and teachers
            </div>
            {/* <div className='mt-4 flex justify-between'>
                <div className='border border-blue-400 transition delay-200 rounded py-2 px-5 text-center text-blue-200 leading-5 text-sm'>
                    Ask Questions
                </div>
                <div className='border border-blue-400 delay-300 rounded py-2 px-5 text-center text-blue-200 leading-5 text-sm'>
                    Follow Instructions
                </div>
                <div className='border border-blue-400 delay-500 rounded py-2 px-5 text-center text-blue-200 leading-5 text-sm'>
                    Have Fun!
                </div>
            </div> */}
        </div>
    </div>
);

export default ChatLanding;